"use client";

import Link from "next/link";
import { useState, useEffect } from 'react';
import Image from "next/image";
import ic_title_blowout_png from "@/app/assets/common/event/ic_title_blowout.png";
import ic_title_hot_png from "@/app/assets/common/event/ic_title_hot.png";
import ic_title_new_png from "@/app/assets/common/event/ic_title_new.png";
import ic_title_tossup_png from "@/app/assets/common/event/ic_title_tossup.png";
import title_ai_insight_png from "@/app/assets/event/title_ai_insight.png"
import type { EventDataType } from "./CardList"

import { BuySell } from "@/app/event/[eventName]/components/BuySell";

export type EventCardProps = {
  data: EventDataType
};

export const EventCard: React.FC<EventCardProps> = ({
  data,
  ...props
}) => {
  const [selectIdx, setSelectIdx] = useState(-1)
  const [type, setType] = useState(1)

  console.log("EventCard")

  return (<div className='cardItem_race'>
    <div className='flex items-center justify-between pt-5 pb-5'>
      <div className='flex leading-20 text-xs'>
        {
          data.event.labels.map((item, index) => (
            item === "HOT" ?
              <span className='font-bold text-error-300 mr-20 flex items-center' key={index}>
                {item}
                <Image
                  src={ic_title_hot_png}
                  alt="HOT" width="16" height="16"
                  style={{ width: "1.6rem", height: "1.6rem" }}
                />
              </span>
              :
              (
                item === "BLOWOUT" ?
                  <span className='font-bold text-warning-200 mr-20 flex items-center' key={index}>
                    {item}
                    <Image
                      src={ic_title_blowout_png}
                      alt="HOT" width="16" height="16"
                      style={{ width: "1.6rem", height: "1.6rem" }}
                    />
                  </span>
                  : (
                    item === "NEW" ?
                      <span className='font-bold text-success-300 mr-20 flex items-center' key={index}>
                        {item}
                        <Image
                          src={ic_title_new_png}
                          alt="HOT" width="16" height="16"
                          style={{ width: "1.6rem", height: "1.6rem" }}
                        />
                      </span>
                      :
                      item === "TOSS-UP" ?
                        <span className='font-bold text-info-100 mr-20 flex items-center' key={index}>
                          {item}
                          <Image
                            src={ic_title_tossup_png}
                            alt="HOT" width="16" height="16"
                            style={{ width: "1.6rem", height: "1.6rem" }}
                          />
                        </span>
                        :
                        <span className='text-bravve-sub-500 mr-20' key={index}>
                          {item}
                        </span>
                  )
              )
          ))
        }
      </div>
      <div className='text-bravve-sub-500'>
        {/* <CountDown timeStamp={1758643200000} /> */}
        {data.event.endDate}
      </div>
    </div>
    <Link href={process.env.NODE_ENV === "development" ? data.event.eventLink.replace("https://askpaul.ai", '') : data.event.eventLink}
      className='flex items-center '>
      <Image
        src={data.event.image}
        alt={data.event.title} width="44" height="44"
        className="object-cover rounded-sm"
        style={{ width: "4.4rem", height: "4.4rem" }}
      />
      <div className='ml-10 text-bravve-200 font-bold text-15'>
        {data.event.title}
      </div>
    </Link>
    {
      data.event.markets.map((item, index) => (
        <div
          className={'flex items-center justify-between min-h-50 ' + (index % 2 === 1 ? '' : 'mt-10')} key={item.id}>
          {
            item.itemTitle ?
              <div className='text-15 text-bravve-200 overflow-hidden whitespace-nowrap text-ellipsis'>
                <span>{item.itemTitle}</span>
              </div>
              :
              null
          }
          <div className={'flex justify-between items-center ' + (item.itemTitle ? '' : 'w-full')}>
            <div className={" button_72 flex items-center justify-center relative font-semibold mr-10 " +
              (item.aiPrediction === item.outcomeName1 ? 'bg-bravve-100' : 'bg-bravve-200') + (item.itemTitle ? ' ml-10' : ' flex-1 button_72_1')}
              onClick={() => { setType(1); setSelectIdx(index); }}
            >
              {
                item.aiPrediction === item.outcomeName1 && <span className='absolute text-7 text-bravve-300 font-black top-2 right-4 leading-12'>AI</span>
              }
              <span className='text-10 text-bravve-sub-400' >{item.outcomeName1}</span>
              <span className='text-15 ml-5 text-bravve-300' >{item.outcomePrice1}</span>
            </div>
            <div className={' button_72 flex items-center justify-center font-semibold relative ' +
              (item.aiPrediction === item.outcomeName2 ? 'bg-bravve-100' : 'bg-bravve-200') + (item.itemTitle ? '' : ' flex-1 button_72_1')}
              onClick={() => { setType(2); setSelectIdx(index); }}
            >
              {
                item.aiPrediction === item.outcomeName2 && <span className='absolute text-7 text-bravve-300 font-black top-2 right-4 leading-12'>AI</span>
              }
              <span className='text-10 text-bravve-sub-400' >{item.outcomeName2}</span>
              <span className='text-15 ml-5 text-bravve-300' >{item.outcomePrice2}</span>
            </div>
          </div>
        </div>
      ))
    }
    {
      data.event.insight ? <>
        <div className='flex items-center mb-6'>
          <div className='leading-12 text-10 font-bold text-bravve-100'>Paul’s Insight</div>
          <Image src={title_ai_insight_png} alt="title_ai_insight" className='w-20 h-20 ml-2' width={20} height={20} />
        </div>
        <div
          className='mt-6 text-sm leading-15'
          style={{ color: "rgba(255,255,255,0.6)" }}
        >
          {data.event.insight}
        </div>
      </>
        :
        null
    }

    {
      selectIdx !== -1 ?
        <BuySell data={data.event.markets[selectIdx]} type={type} onClose={() => setSelectIdx(-1)} />
        : null
    }

  </div>)
}